import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";
import PatientTable from "./PatientTable";
import { AddPatientModal } from "./AddPatientModal";
import { ErrorSuccessModal } from "../../Modals/ErrorSuccessModal";
import { usePatients } from "../../hooks/usePatients";

const PatientsPage = () => {
  useEffect(() => {
    const savedTheme = localStorage.getItem("app-theme") || "teal";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  // Παίρνουμε τα πάντα από το hook!
  const {
    patients = [],
    isLoading,
    createPatient,
    modalState,
    closeModal,
  } = usePatients();

  return (
    <Layout>
      <main className="w-full">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">
            Διαχείριση Ασθενών
          </h1>
          <button
            onClick={() => setIsAddModalOpen(true)}
            className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-darkprimary transition font-medium"
          >
            + Νέος Ασθενής
          </button>
        </div>

        <PatientTable patients={patients} loading={isLoading} />
      </main>

      {/* Modal Φόρμας Προσθήκης */}
      <AddPatientModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSubmit={createPatient} // Περνάμε τη συνάρτηση του hook
      />

      {/* Global Error/Success Modal από το hook */}
      <ErrorSuccessModal
        isOpen={modalState.isOpen}
        title={modalState.title}
        message={modalState.message}
        type={modalState.type}
        onClose={closeModal}
      />
    </Layout>
  );
};

export default PatientsPage;
